import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { Pie, Bar, Doughnut } from 'react-chartjs-2';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import { message, Tooltip } from 'antd'
import { Dashboard1 } from './Dashboard1'
import { Dashboard2 } from './Dashboard2'
import { Dashboard3 } from './Dashboard3'
import { Dashboard4 } from './Dashboard4'
import * as DashbaordAPI from '../../services/Dashboard'
import { fontSize } from '@mui/system';

const DashboardPage: FC = () => {
  const [intentFrequency, setIntentFrequency] = useState({ labels: [], datasets: [{ "label": "", "data": [] }], raw_data: [] })
  const [fallback, setFallback] = useState({ labels: [], datasets: [{ "label": "", "data": [] }] })
  const [chatPerMessage, setChatPerMessage] = useState({ labels: [], datasets: [{ "label": "", "data": [] }], raw_data: [] })
  const [top5intent, setTop5intent] = useState([])

  useEffect(() => {
    initData()
  }, [])

  const initData = async () => {
    getDashboardData()
  }

  const getDashboardData = async () => {
    try {
      let res_dashboard = await DashbaordAPI.getDashboardData()
      if (res_dashboard.status === 200) {
        let { intentFrequency, fallback, chatPerMessage, top5intent } = res_dashboard.data
        let newData: any = []
        let tempRawData: any = []
        //// Start : fix format decimal 2 digit
        if (intentFrequency && intentFrequency.datasets[0].data.length > 0) {
          intentFrequency.datasets[0].data.map((item: any) => {
            newData.push(item.toFixed(2))
          })
        }
        intentFrequency.datasets[0].data = newData
        newData = []
        if (fallback && fallback.datasets[0].data.length > 0) {
          fallback.datasets[0].data.map((item: any) => {
            newData.push(item.toFixed(2))
          })
        }
        fallback.datasets[0].data = newData
        newData = []
        //// End : fix format decimal 2 digit

        //// Start : change format raw data to list
        if (intentFrequency && intentFrequency.raw_data.length > 0) {
          intentFrequency.raw_data.map((item: any) => {
            tempRawData.push(item.count)
          })
        }
        intentFrequency.raw_data = tempRawData
        //// End : change format raw data to list
        tempRawData = []
        //// Start : change format raw data to list
        if (fallback && fallback.raw_data.countFallback.length > 0) {
          fallback.raw_data.countFallback.map((item: any) => {
            tempRawData.push(item._count.is_fallback)
          })
        }
        fallback.raw_data = tempRawData
        //// End : change format raw data to list
        setIntentFrequency(intentFrequency)
        setFallback(fallback)
        setChatPerMessage(chatPerMessage)
        setTop5intent(top5intent)
      }
    } catch (error: any) {
      console.log('error', error)
      if (error?.response?.message) {
        message.error(error.response.message)
      }
    }
  }
  const backgroundColor1 = [
    '#36688d',
    '#7A77FF',
    '#F4C3D9',
    '#FEBBBA',
    '#F4874C',
    '#F46A4E',
  ]
  const listItemStyle: any = {
    color: "#333",
    listStyle: "none",
    textAlign: "left",
    display: "flex",
    flexDirection: "row",
    margin: "8px",
    fontSize: "12px",
  };
  const backgroundColor2 = [
    'red',
    '#26A65B',
  ]

  const legend: any = ["January", "February"]
  return (
    <>
      {/* begin::Row */}
      <div className='row gy-5 g-xl-8'>
        <div className={`card card-xl-stretch mb-xl-8 bg-white`}>
          <div className='card-body pt-5 p-8'>
            <div className='row mb-15' >
              <div className='col-xl-6' >
                <div className='row'>
                  <div className='col-8'>
                    <Dashboard1 dataSource={intentFrequency} />
                  </div>
                  <div className='col-4'>
                    <ul className="mt-8" style={{ paddingLeft: 0, overflow: 'scroll', maxHeight: 400 }}>
                      {intentFrequency.labels.length > 0 &&
                        intentFrequency.labels.map((item: any, index: number) => {
                          let percent: any = intentFrequency.datasets[0].data[index]
                          return (
                            <li key={item} style={listItemStyle}>
                              <div
                                style={{
                                  marginRight: "5px",
                                  paddingRight: "15px",
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: backgroundColor1[index % 6],
                                }}
                              />
                              <Tooltip placement="topLeft" title={item + " " + percent + "%"}>
                                <span>{item} {percent}%</span>
                              </Tooltip>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                </div>
              </div>
              <div className='col-xl-6 mt-20'>
                <Dashboard3 dataSource={chatPerMessage} />
              </div>
            </div>
            <div className='row'>
              <div className='col-xl-6'>
                <div className='row'>
                  <div className='col-8'>
                    <Dashboard2 dataSource={fallback} />
                  </div>
                  <div className='col-4'>
                    <ul className="mt-8" style={{ paddingLeft: 0 }}>
                      {fallback.labels.length > 0 &&
                        fallback.labels.map((item: any, index: number) => {
                          let percent: any = fallback.datasets[0].data[index]
                          return (
                            <li key={item} style={listItemStyle}>
                              <div
                                style={{
                                  marginRight: "5px",
                                  paddingRight: "15px",
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: backgroundColor2[index % 2],
                                }}
                              />
                              <Tooltip placement="topLeft" title={item + " " + percent + "%"}>
                                <div >{item} {percent}%</div>
                              </Tooltip>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                </div>
              </div>
              <div className='col-xl-6 mt-10'>
                <Dashboard4 dataSource={top5intent} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const DashboardWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>แดชบอร์ด</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
